import { useState, useEffect } from 'react';
import Block from './Block';
import { initializeGrid, swapBlocks, findMatches, handleMatches, dropBlocks, setUserInteracted, clearRow, clearColumn, applyBomb } from '../utils/gameLogic';
import styles from './GameBoard.module.css';


const GameBoard = ({ level, onWin, onLose, onScoreUpdate }) => {
  const [grid, setGrid] = useState(() => initializeGrid(level.gridWidth, level.gridHeight, level.obstacles));
  const [score, setScore] = useState(0);
  const [movesLeft, setMovesLeft] = useState(level.moves);

  useEffect(() => {
    const processMatches = () => {
      let newGrid = grid;
      let totalScore = score;
      let hasMatches = false;

      do {
        const matches = findMatches(newGrid);
        if (matches.length > 0) {
          hasMatches = true;
          const result = handleMatches(newGrid, matches);
          newGrid = result.grid;
          totalScore += result.score;
          newGrid = dropBlocks(newGrid);
        } else {
          hasMatches = false;
        }
      } while (hasMatches);

      setGrid(newGrid);
      setScore(totalScore);
      onScoreUpdate(totalScore);
      if (totalScore >= level.targetScore) onWin();
      else if (movesLeft <= 0) onLose();
    };

    processMatches();
  }, [grid, score, movesLeft, level.targetScore, onWin, onLose, onScoreUpdate]);

  const handleSwipe = (startRow, startCol, direction) => {
    console.log('Handling swipe from', startRow, startCol, 'direction:', direction);

    setUserInteracted();

    let endRow = startRow;
    let endCol = startCol;

    switch (direction) {
      case 'left':
        endCol = Math.max(0, startCol - 1);
        break;
      case 'right':
        endCol = Math.min(level.gridWidth - 1, startCol + 1);
        break;
      case 'up':
        endRow = Math.max(0, startRow - 1);
        break;
      case 'down':
        endRow = Math.min(level.gridHeight - 1, startRow + 1);
        break;
      default:
        return;
    }

    console.log('Swapping to', endRow, endCol);

    const newGrid = swapBlocks(grid, [startRow, startCol], [endRow, endCol]);
    setGrid(newGrid);
    setMovesLeft(moves => moves - 1);
  };

  const handleSpecialBlockActivate = (row, col, type) => {
    console.log('Activating special block at', row, col, 'type:', type);

    setUserInteracted();
    let newGrid = grid.map(row => [...row]);
    let scoreDelta = 0;

    if (type === 'stripe_horizontal') {
      scoreDelta = clearRow(newGrid, row);
    } else if (type === 'stripe_vertical') {
      scoreDelta = clearColumn(newGrid, col);
    } else if (type === 'bomb') {
      scoreDelta = applyBomb(newGrid, row, col);
    }

    newGrid = dropBlocks(newGrid);
    setGrid(newGrid);
    setScore(score => score + scoreDelta);
    setMovesLeft(moves => moves - 1);
  };

  return (
    <div className={styles.board} style={{ gridTemplateColumns: `repeat(${level.gridWidth}, 1fr)` }}>
      {grid.map((row, rowIndex) =>
        row.map((block, colIndex) => (
          <Block
            key={`${rowIndex}-${colIndex}`}
            block={block}
            row={rowIndex}
            col={colIndex}
            onSwipe={handleSwipe}
            onSpecialBlockActivate={handleSpecialBlockActivate}
          />
        ))
      )}
      <div className={styles.info}>
        Score: {score} / {level.targetScore} | Moves: {movesLeft}
      </div>
    </div>
  );
};

export default GameBoard;